//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.2'.
//
package de.katoonerie

import com.apollographql.apollo3.annotations.ApolloAdaptableWith
import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.CompiledField
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.Optional
import com.apollographql.apollo3.api.Query
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.obj
import de.katoonerie.adapter.HomepageQuery_ResponseAdapter
import de.katoonerie.adapter.HomepageQuery_VariablesAdapter
import de.katoonerie.selections.HomepageQuerySelections
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public data class HomepageQuery(
  public val preview: Optional<Boolean?> = Optional.Absent,
) : Query<HomepageQuery.Data> {
  public override fun id(): String = OPERATION_ID

  public override fun document(): String = OPERATION_DOCUMENT

  public override fun name(): String = OPERATION_NAME

  public override fun serializeVariables(writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters): Unit {
    HomepageQuery_VariablesAdapter.toJson(writer, customScalarAdapters, this)
  }

  public override fun adapter(): Adapter<Data> = HomepageQuery_ResponseAdapter.Data.obj()

  public override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = de.katoonerie.type.Query.type
  )
  .selections(selections = HomepageQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(HomepageQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val homepageCollection: HomepageCollection?,
  ) : Query.Data

  public data class HomepageCollection(
    public val items: List<Item?>,
  ) {
    public fun itemsFilterNotNull(): List<Item> = items.filterNotNull()
  }

  public data class Item(
    public val backgroundColor: BackgroundColor?,
    public val accentColor: AccentColor?,
    public val banner: Banner?,
    public val navigationBarsCollection: NavigationBarsCollection?,
    public val actionsBar: ActionsBar?,
    public val introduction: Introduction?,
  )

  public data class BackgroundColor(
    public val hex: String?,
  )

  public data class AccentColor(
    public val hex: String?,
  )

  public data class Banner(
    public val url: String?,
  )

  public data class NavigationBarsCollection(
    public val items: List<Item1?>,
  ) {
    public fun itemsFilterNotNull(): List<Item1> = items.filterNotNull()
  }

  public data class Item1(
    public val page: Page?,
    public val navigationItemsCollection: NavigationItemsCollection?,
  )

  public data class Page(
    public val name: String?,
    public val url: String?,
  )

  public data class NavigationItemsCollection(
    public val items: List<Item2?>,
  ) {
    public fun itemsFilterNotNull(): List<Item2> = items.filterNotNull()
  }

  public data class Item2(
    public val tile: Tile?,
    public val color: Color?,
    public val icon: Icon?,
  )

  public data class Tile(
    public val name: String?,
    public val slug: String?,
  )

  public data class Color(
    public val hex: String?,
  )

  public data class Icon(
    public val url: String?,
  )

  public data class ActionsBar(
    public val page: Page1?,
    public val navigationItemsCollection: NavigationItemsCollection1?,
  )

  public data class Page1(
    public val name: String?,
    public val url: String?,
  )

  public data class NavigationItemsCollection1(
    public val items: List<Item3?>,
  ) {
    public fun itemsFilterNotNull(): List<Item3> = items.filterNotNull()
  }

  public data class Item3(
    public val tile: Tile1?,
    public val color: Color1?,
    public val icon: Icon1?,
  )

  public data class Tile1(
    public val name: String?,
    public val slug: String?,
  )

  public data class Color1(
    public val hex: String?,
  )

  public data class Icon1(
    public val url: String?,
  )

  public data class Introduction(
    public val text: Text?,
  )

  public data class Text(
    public val json: Any,
    public val links: Links,
  )

  public data class Links(
    public val entries: Entries,
    public val assets: Assets,
  )

  public data class Entries(
    public val block: List<Block?>,
  ) {
    public fun blockFilterNotNull(): List<Block> = block.filterNotNull()
  }

  public data class Block(
    public val __typename: String,
    /**
     * Synthetic field for inline fragment on Container
     */
    public val onContainer: OnContainer?,
  )

  public data class OnContainer(
    public val sys: Sys,
    public val name: String?,
    public val textColor: TextColor?,
    public val backgroundColor: BackgroundColor1?,
    public val borderColor: BorderColor?,
    public val mediaCollection: MediaCollection?,
    public val youTubeVideosCollection: YouTubeVideosCollection?,
  )

  public data class Sys(
    public val id: String,
  )

  public data class TextColor(
    public val hex: String?,
  )

  public data class BackgroundColor1(
    public val hex: String?,
  )

  public data class BorderColor(
    public val hex: String?,
  )

  public data class MediaCollection(
    public val items: List<Item4?>,
  ) {
    public fun itemsFilterNotNull(): List<Item4> = items.filterNotNull()
  }

  public data class Item4(
    public val title: String?,
    public val url: String?,
  )

  public data class YouTubeVideosCollection(
    public val items: List<Item5?>,
  ) {
    public fun itemsFilterNotNull(): List<Item5> = items.filterNotNull()
  }

  public data class Item5(
    public val name: String?,
    public val videoId: String?,
  )

  public data class Assets(
    public val block: List<Block1?>,
  ) {
    public fun blockFilterNotNull(): List<Block1> = block.filterNotNull()
  }

  public data class Block1(
    public val contentType: String?,
    public val sys: Sys1,
    public val title: String?,
    public val url: String?,
  )

  public data class Sys1(
    public val id: String,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "4261312f353e9ca7451f10b3d955292790d793f67b35cdbd2981296c3daefd7f"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * query Homepage($preview: Boolean) {
     *   homepageCollection(limit: 1, preview: $preview) {
     *     items {
     *       backgroundColor {
     *         hex
     *       }
     *       accentColor {
     *         hex
     *       }
     *       banner {
     *         url(transform: {
     *           height: 300
     *           format: JPG
     *           quality: 90
     *         }
     *         )
     *       }
     *       navigationBarsCollection(limit: 3) {
     *         items {
     *           page {
     *             name
     *             url
     *           }
     *           navigationItemsCollection(limit: 11) {
     *             items {
     *               tile {
     *                 name
     *                 slug
     *               }
     *               color {
     *                 hex
     *               }
     *               icon {
     *                 url(transform: {
     *                   width: 100
     *                   height: 100
     *                   resizeStrategy: FIT
     *                 }
     *                 )
     *               }
     *             }
     *           }
     *         }
     *       }
     *       actionsBar {
     *         page {
     *           name
     *           url
     *         }
     *         navigationItemsCollection(limit: 11) {
     *           items {
     *             tile {
     *               name
     *               slug
     *             }
     *             color {
     *               hex
     *             }
     *             icon {
     *               url(transform: {
     *                 width: 100
     *                 height: 100
     *                 resizeStrategy: FIT
     *               }
     *               )
     *             }
     *           }
     *         }
     *       }
     *       introduction {
     *         text {
     *           json
     *           links {
     *             entries {
     *               block {
     *                 __typename
     *                 ... on Container {
     *                   sys {
     *                     id
     *                   }
     *                   name
     *                   textColor {
     *                     hex
     *                   }
     *                   backgroundColor {
     *                     hex
     *                   }
     *                   borderColor {
     *                     hex
     *                   }
     *                   mediaCollection(limit: 1) {
     *                     items {
     *                       title
     *                       url(transform: {
     *                         width: 520
     *                         format: PNG
     *                       }
     *                       )
     *                     }
     *                   }
     *                   youTubeVideosCollection(limit: 1) {
     *                     items {
     *                       name
     *                       videoId
     *                     }
     *                   }
     *                 }
     *               }
     *             }
     *             assets {
     *               block {
     *                 contentType
     *                 sys {
     *                   id
     *                 }
     *                 title
     *                 url(transform: {
     *                   width: 520
     *                   format: PNG
     *                 }
     *                 )
     *               }
     *             }
     *           }
     *         }
     *       }
     *     }
     *   }
     * }
     */
    public val OPERATION_DOCUMENT: String
      get() =
          "query Homepage(${'$'}preview: Boolean) { homepageCollection(limit: 1, preview: ${'$'}preview) { items { backgroundColor { hex } accentColor { hex } banner { url(transform: { height: 300 format: JPG quality: 90 } ) } navigationBarsCollection(limit: 3) { items { page { name url } navigationItemsCollection(limit: 11) { items { tile { name slug } color { hex } icon { url(transform: { width: 100 height: 100 resizeStrategy: FIT } ) } } } } } actionsBar { page { name url } navigationItemsCollection(limit: 11) { items { tile { name slug } color { hex } icon { url(transform: { width: 100 height: 100 resizeStrategy: FIT } ) } } } } introduction { text { json links { entries { block { __typename ... on Container { sys { id } name textColor { hex } backgroundColor { hex } borderColor { hex } mediaCollection(limit: 1) { items { title url(transform: { width: 520 format: PNG } ) } } youTubeVideosCollection(limit: 1) { items { name videoId } } } } } assets { block { contentType sys { id } title url(transform: { width: 520 format: PNG } ) } } } } } } } }"

    public const val OPERATION_NAME: String = "Homepage"
  }
}
